import SEO from '../components/SEO';
import SoftwareHero from '../components/sections/owner-operator/SoftwareHero';
import PainSection from '../components/sections/owner-operator/PainSection';
import SolutionSection from '../components/sections/owner-operator/SolutionSection';
import TimePaybackSection from '../components/sections/owner-operator/TimePaybackSection';
import UrgencySection from '../components/sections/owner-operator/UrgencySection';
import CalendarSection from '../components/sections/owner-operator/CalendarSection';
import QualificationSection from '../components/sections/owner-operator/QualificationSection';
import FooterCTA from '../components/sections/owner-operator/FooterCTA';
import LatestInsights from '../components/sections/home/LatestInsights';
import StickyCTA from '../components/sections/owner-operator/StickyCTA';

/**
 * Home Page - San Gabriel Solutions
 * Owner-Operator Software Focus:
 * - Hero: Software built for Owner-Operators
 * - Pain points section
 * - Solution overview
 * - Time/payback calculator
 * - Urgency messaging
 * - Booking calendar
 * - Qualification section
 * - Latest Insights (Added for AdSense)
 * - Footer CTA
 * - Sticky mobile CTA
 */
export default function Home() {
  return (
    <div className="pt-20">
      <SEO
        title="Software Built for Owner-Operators: Save Hours Every Week"
        description="Automate daily tasks, reduce manual work, and free up hours every week. Free for the first 100 owner-operators."
        keywords="owner-operator software, time saving, automation, small business, workflow management"
      />

      {/* SoftwareHero */}
      <SoftwareHero />

      {/* PainSection */}
      <PainSection />

      {/* SolutionSection */}
      <SolutionSection />

      {/* TimePaybackSection */}
      <TimePaybackSection />

      {/* UrgencySection */}
      <UrgencySection />

      {/* CalendarSection */}
      <CalendarSection />

      {/* QualificationSection */}
      <QualificationSection />

      {/* LatestInsights - Added for content depth */}
      <LatestInsights />

      {/* FooterCTA */}
      <FooterCTA />

      {/* StickyCTA (mobile only) */}
      <StickyCTA />
    </div>
  );
}
